import {withStyles} from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import {Box, FormControl, Grid, InputLabel, Select, TextField, Typography} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import {CheckoutListService, checkoutStatus} from "./CheckoutListService";
import {useEffect, useState} from "react";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import moment from "jalali-moment";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import DefaultDialogPage, {DialogSize} from "../defaultDialogPage/DefaultDialogPage";
import DeleteConfirmDialog from "../deleteConfirmDialog/DeleteConfirmDialog";

const CheckOutDetails = ({selectedItemId, openDialog, handleClose, changeNeedRefresh}) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new CheckoutListService(fundID, token, snackbar, loading)


    //Dialog-start
    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });
    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });
    const DialogContent = withStyles((theme) => ({
        root: {
            padding: theme.spacing(2),
        },
    }))(MuiDialogContent);

    const DialogActions = withStyles((theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(1),
        },
    }))(MuiDialogActions);
    //Dialog-end

    const [fullName, setFullName] = useState("");
    const [accountCode, setAccountCode] = useState("");
    const [requesterInfo, setRequesterInfo] = useState("");
    const [status, setStatus] = useState(checkoutStatus.AWAITING_FOR_REVIEW.id);
    const [description, setDescription] = useState("");
    const [sendAt, setSendAt] = useState("");
    const [depositAccountId, setDepositAccountId] = useState(-1);

    const [canUpdated, setCanUpdated] = useState(false);

    useEffect(() => {
        if (selectedItemId >= 0) {
            getCheckoutInfoFromServer()
        }
    }, [selectedItemId])

    useEffect(() => {
        if (!openDialog) {
            clearFields()
        }
    }, [openDialog])

    function clearFields() {
        setFullName("")
        setAccountCode("")
        setRequesterInfo("")
        setStatus(checkoutStatus.AWAITING_FOR_REVIEW.id)
    }


    function getCheckoutInfoFromServer() {
        loading(setLoadingStateDispatch(true))
        service.getCheckoutInfo(fundID, selectedItemId)
            .then(response => {
                setFullName(response.ownerFullName)
                setAccountCode(response.depositAccountId)
                setDepositAccountId(response.depositAccountId)
                setRequesterInfo(response.sendBy)
                setSendAt(response.sendAt)
                setDescription(response.description)

                setStatus(response.status)
                setCanUpdated(response.status === checkoutStatus.AWAITING_FOR_REVIEW.id)

                loading(setLoadingStateDispatch(false))
            }).catch(reason => {
            ServerErrorHandler(reason, "خطا در دریافت جزئیات تسویه حساب!", snackbar, loading)
        })
    }


    function handleChangeState() {
        changeNeedRefresh(true)

        if (status === checkoutStatus.AWAITING_FOR_REVIEW.id) {

        } else if (status === checkoutStatus.REJECTED.id) {
            service.rejectSettlementRequest(fundID, selectedItemId)
        } else if (status === checkoutStatus.ACCEPTED.id) {
            handleOpenDeleteDialog()
        }
    }

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

    function handleOpenDeleteDialog() {

        setOpenDeleteDialog(true)
    }

    function handleCloseDeleteDialog() {
        setOpenDeleteDialog(false)
    }

    function doDeleteItem() {
        loading(setLoadingStateDispatch(true))
        service.acceptSettlementRequest(fundID, selectedItemId)
            .then(response => {
                getCheckoutInfoFromServer()
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "تسویه حساب کاربر با موفقیت انجام شد."))
                loading(setLoadingStateDispatch(false))
            }).catch(reason => {
            ServerErrorHandler(reason, "خطا در تسویه حساب کاربر!", snackbar, loading)
        })
    }

    return (
        <>
            <Dialog onClose={handleClose} open={openDialog}
                    id="PersonalizedDialog">
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    تسویه حساب
                </DialogTitle>
                <DialogContent>
                    <Box className="d-flex flex-column">
                        <Grid xs={12} className="w-100 p-2">
                            <TextField
                                className="w-100"
                                disabled
                                value={fullName}
                                id="outlined-disabled"
                                label="صاحب حساب"
                                variant="outlined"
                            />
                        </Grid>
                        <Grid xs={12} className="w-100 p-2">
                            <TextField
                                className="w-100"
                                disabled
                                id="outlined-disabled"
                                value={accountCode}
                                label="کد حساب"
                                variant="outlined"
                            />
                        </Grid>
                        <Grid xs={12} className="w-100 p-2">
                            <TextField
                                className="w-100"
                                disabled
                                id="outlined-disabled"
                                label="درخواست کننده"
                                value={requesterInfo}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid xs={12} className="w-100 p-2">
                            <TextField
                                className="w-100"
                                disabled
                                id="outlined-disabled"
                                label="تاریخ درخواست"
                                value={sendAt ? moment(sendAt, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : "-"}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid xs={12} className="w-100 p-2">
                            <TextField
                                className="w-100"
                                disabled
                                multiline
                                rows={3}
                                id="outlined-disabled"
                                label="توضیحات"
                                value={description}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid xs={12} className="w-100 p-2">
                            <FormControl variant="outlined" className="w-100">
                                <InputLabel htmlFor="filled-age-native-simple">وضعیت</InputLabel>
                                <Select
                                    onChange={e => {
                                        setStatus(e.target.value)
                                    }}
                                    disabled={!canUpdated}
                                    value={status}
                                    label="وضعیت">
                                    <option
                                        className="bg_default_state"
                                        value={checkoutStatus.AWAITING_FOR_REVIEW.id}>{checkoutStatus.AWAITING_FOR_REVIEW.title}</option>
                                    <option
                                        className="bg_deActive_state"
                                        value={checkoutStatus.REJECTED.id}>{checkoutStatus.REJECTED.title}</option>
                                    <option
                                        className="bg_active_state"
                                        value={checkoutStatus.ACCEPTED.id}>{checkoutStatus.ACCEPTED.title}</option>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid xs={12} className="w-100 p-2">
                            <Button autoFocus className={canUpdated ? "w-100" : "d-none"} onClick={handleChangeState}
                                    color="primary">
                                بروزرسانی
                            </Button>
                        </Grid>
                    </Box>
                </DialogContent>
            </Dialog>

            <DefaultDialogPage
                onClose={handleCloseDeleteDialog}
                open={openDeleteDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle={"تسویه حساب"}
            >
                <DeleteConfirmDialog
                    closeDialog={handleCloseDeleteDialog}
                    doDelete={doDeleteItem}
                    title={"آیا از تسویه حساب کاربر اطمینان دارید؟"}
                    description={"با اتمام فرایند، حساب تسویه شده و قابل بازگشت نخواهد بود!"}
                    submitTitle={"تسویه حساب"}
                />
            </DefaultDialogPage>

        </>
    )
}
export default CheckOutDetails;